import moment from 'moment-timezone';

export default function() {
  return (timestamp, locale, timeZone) => {
    if (
      timestamp === null ||
      timestamp === '' ||
      typeof timestamp === 'undefined'
    )
      return '';
    moment.locale(locale);
    const timezone = timeZone || moment.tz.guess();
    return moment.tz(timestamp, timezone).format('L h:mm A zz');
  };
}
